export const Planet = () => (
  <svg
    width="24px"
    height="24px"
    strokeWidth="1.5"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="12" cy="12" r="8" strokeWidth="1.5"></circle>
    <path
      d="M17.4995 6.34835C19.7975 5.80967 21.4447 5.87208 21.8376 6.66002C22.5686 8.12616 18.6797 11.5491 13.1515 14.3053C7.62327 17.0616 2.5492 18.1074 1.81821 16.6413C1.4263 15.8553 2.36234 14.5067 4.16701 13.0001"
      strokeWidth="1.5"
    ></path>
  </svg>
);

export const Shop = () => (
  <svg
    width="24px"
    height="24px"
    strokeWidth="1.5"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3 10V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V10"
      strokeWidth="1.5"
    ></path>
    <path
      d="M14.8333 21V15C14.8333 13.8954 13.9379 13 12.8333 13H10.8333C9.72874 13 8.83331 13.8954 8.83331 15V21"
      strokeWidth="1.5"
      strokeMiterlimit="16"
    ></path>
    <path
      d="M21.8183 9.36418L20.1243 3.43517C20.0507 3.17759 19.8153 3 19.5474 3H15.5L15.9753 8.70377C15.9909 8.89043 16.0923 9.05904 16.2532 9.15495C16.6425 9.38698 17.4052 9.81699 18 10C19.0158 10.3125 20.5008 10.1998 21.3465 10.0958C21.6982 10.0526 21.9157 9.7049 21.8183 9.36418Z"
      strokeWidth="1.5"
    ></path>
    <path
      d="M14 10C14.5675 9.82538 15.2879 9.42589 15.6909 9.18807C15.8828 9.07486 15.9884 8.86103 15.9699 8.63904L15.5 3H8.5L8.03008 8.63904C8.01158 8.86103 8.11723 9.07486 8.30906 9.18807C8.71207 9.42589 9.4325 9.82538 10 10C11.493 10.4594 12.507 10.4594 14 10Z"
      strokeWidth="1.5"
    ></path>
    <path
      d="M3.87567 3.43517L2.18166 9.36418C2.08431 9.7049 2.3018 10.0526 2.6535 10.0958C3.49916 10.1998 4.98424 10.3125 6 10C6.59477 9.81699 7.35751 9.38698 7.74678 9.15495C7.90767 9.05904 8.00913 8.89043 8.02469 8.70377L8.5 3H4.45258C4.18469 3 3.94926 3.17759 3.87567 3.43517Z"
      strokeWidth="1.5"
    ></path>
  </svg>
);

export const Star = () => (
  <svg
    width="24px"
    height="24px"
    strokeWidth="1.5"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 18C15.3137 18 18 15.3137 18 12C18 8.68629 15.3137 6 12 6C8.68629 6 6 8.68629 6 12C6 15.3137 8.68629 18 12 18Z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></path>
    <path
      d="M22 12L23 12"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></path>
    <path
      d="M12 2V1"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></path>
    <path
      d="M12 23V22"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></path>
    <path
      d="M20 20L19 19"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></path>
    <path
      d="M20 4L19 5"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></path>
    <path
      d="M4 20L5 19"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></path>
    <path
      d="M4 4L5 5"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></path>
    <path
      d="M1 12L2 12"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></path>
  </svg>
);

export const Jump = () => (
  <svg
    width="800px"
    height="800px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="12" cy="12" r="2" stroke="#1C274C" strokeWidth="1.5" />
    <path
      d="M12 10C17 10 16.6 22 9 22"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M12.3115 14C7.31152 14 7.71152 2 15.3115 2"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M10.6316 10.6961C14.1671 7.16053 22.3695 15.9287 16.9955 21.3027"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeDasharray="2 2"
    />
    <path
      d="M13.6799 13.3039C10.1444 16.8395 1.94198 8.07135 7.31599 2.69734"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeDasharray="2 2"
    />
    <path
      d="M10.8513 13.5242C7.3158 9.98865 16.0839 1.78622 21.4579 7.16023"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeDasharray="2 2"
    />
    <path
      d="M13.4602 10.4758C16.9957 14.0113 8.2276 22.2138 2.85359 16.8398"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeDasharray="2 2"
    />
    <path
      d="M10 12.3115C10 7.31152 22 7.71152 22 15.3115"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path d="M14 12C14 17 2 16.6 2 9" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

export const Lootable = () => (
  <svg
    width="800px"
    height="800px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21 12.4984L14 12.4984M3 12.4984L10 12.4984M7 4.5V19.4984M17 4.5V19.4984M6.2 19.5H17.8C18.9201 19.5 19.4802 19.5 19.908 19.282C20.2843 19.0903 20.5903 18.7843 20.782 18.408C21 17.9802 21 17.4201 21 16.3V10.9C21 8.65979 21 7.53968 20.564 6.68404C20.1805 5.93139 19.5686 5.31947 18.816 4.93597C17.9603 4.5 16.8402 4.5 14.6 4.5H9.4C7.15979 4.5 6.03968 4.5 5.18404 4.93597C4.43139 5.31947 3.81947 5.93139 3.43597 6.68404C3 7.53968 3 8.65979 3 10.9V16.3C3 17.4201 3 17.9802 3.21799 18.408C3.40973 18.7843 3.71569 19.0903 4.09202 19.282C4.51984 19.5 5.07989 19.5 6.2 19.5ZM10 10.4984H14V14.4984H10V10.4984Z"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </svg>
);

export const Unknown = () => (
  <svg
    width="24px"
    height="24px"
    strokeWidth="1.5"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.90039 8.07954C7.90039 3.30678 15.4004 3.30682 15.4004 8.07955C15.4004 11.4886 11.9913 10.8067 11.9913 14.8976"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></path>
    <path
      d="M12 19.01L12.01 18.9989"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></path>
  </svg>
);

export const System = () => (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 32 32"
    fill="none"
  >
    <circle
      className="st0"
      cx="16"
      cy="16"
      r="3"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
    />
    <circle
      className="st0"
      cx="25"
      cy="7"
      r="2"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
    />
    <circle
      className="st0"
      cx="15"
      cy="24"
      r="2"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
    />
    <path
      className="st0"
      d="M13,23.4c-2.9-1.2-5-4.1-5-7.4c0-4.4,3.6-8,8-8s8,3.6,8,8c0,4.1-3.1,7.5-7,7.9"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
    />
    <path
      className="st0"
      d="M26.5,8.3c1.6,2.2,2.5,4.8,2.5,7.7c0,7.2-5.8,13-13,13S3,23.2,3,16S8.8,3,16,3c2.9,0,5.5,0.9,7.7,2.5"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
    />
  </svg>
);

export const Asteroid = () => (
  <svg
    height="800px"
    width="800px"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 511.999 511.999"
    className="fill"
  >
    <path d="M267.956,106.504c-27.302,0-49.514,22.212-49.514,49.514c0,27.303,22.212,49.515,49.514,49.515    c27.303,0,49.515-22.212,49.515-49.515C317.472,128.718,295.26,106.504,267.956,106.504z M267.956,172.145    c-8.891,0-16.124-7.233-16.124-16.125c0-8.891,7.233-16.124,16.124-16.124c8.892,0,16.125,7.233,16.125,16.124    C284.082,164.911,276.848,172.145,267.956,172.145z" />
    <path d="M484.187,176.66c-24.868-38.094-61.065-69.067-78.533-81.363l-2.41-1.697c-32.93-23.205-78.03-54.985-129.276-54.985    c-2.863,0-5.814-0.007-8.838-0.014c-52.572-0.111-118.016-0.274-147.238,28.95l-89.708,89.708    c-15.07,15.07-25.129,39.431-27.597,66.838c-1.944,21.592,0.012,54.623,20.375,89.36c15.9,27.124,41.319,66.998,78.322,99.971    c44.643,39.78,95.325,59.951,150.64,59.951c2.451,0,4.914,0.008,7.388,0.016c2.574,0.009,5.163,0.018,7.773,0.018    c44.487,0,94.002-2.4,139.991-48.39c47.924-47.924,70.628-80.601,89.775-109.965C520.9,275.11,517.214,227.253,484.187,176.66z     M95.889,362.404c-20.244-23.342-35.462-47.651-46.122-65.834c-5.852-9.981-9.752-19.76-12.276-28.971    c10-28.327,37.163-47.773,67.492-47.773c39.474,0,71.588,32.115,71.588,71.587c0,39.475-32.115,71.588-71.588,71.588    C101.941,363,98.9,362.785,95.889,362.404z M381.466,401.411c-5.405,5.405-10.861,10.031-16.362,14.032    c-16.676-1.711-32.121-9.147-43.931-21.293c-13.054-13.426-20.243-31.137-20.243-49.87c0-39.474,32.115-71.587,71.587-71.587    c17.932,0,35.085,6.661,48.301,18.757c11.626,10.641,19.338,24.664,22.114,39.978    C428.291,351.041,409.385,373.492,381.466,401.411z M466.882,296.819c-0.134,0.206-0.27,0.413-0.405,0.619    c-5.699-11.423-13.495-21.813-23.116-30.618c-19.387-17.743-44.547-27.517-70.845-27.517    c-57.885,0-104.977,47.093-104.977,104.977c0,27.477,10.547,53.453,29.696,73.148c6.979,7.177,14.83,13.222,23.31,18.065    c-20.443,4.632-41.486,4.573-63.126,4.511c-2.51-0.009-5.008-0.017-7.494-0.017c-44.336,0-85.39-15.507-122.151-46.096    c46.964-10.437,82.19-52.418,82.19-102.48c0-57.885-47.093-104.977-104.978-104.977c-25.806,0-50.046,9.612-68.722,25.786    c3.584-15.012,9.916-25.737,15.532-31.352l89.709-89.708c18.033-18.033,75.57-19.183,114.879-19.183    c3.003,0,5.907,0.007,8.671,0.013c3.051,0.008,6.028,0.014,8.916,0.014c40.664,0,80.763,28.257,110.044,48.89l2.424,1.706    c15.522,10.926,47.689,38.452,69.792,72.312C481.823,234.123,485.407,268.408,466.882,296.819z" />
  </svg>
);

export const Nebula = () => (
  <svg
    width="24px"
    height="24px"
    strokeWidth="1.5"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 4C6 4 6 8 6 10C4.33333 10 1 11 1 15C1 19 4.33333 20 6 20H18C19.6667 20 23 19 23 15C23 11 19.6667 10 18 10C18 8 18 4 12 4Z"
      strokeWidth="1.5"
      strokeLinejoin="round"
    ></path>
  </svg>
);

export const Mining = () => (
  <svg
    width="800px"
    height="800px"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    className="fill"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      stroke="none"
      d="M3.02172 1.79241C3.11977 1.33042 3.52766 1 3.99994 1H7.49994C10.8167 1 13.9504 2.15662 16.5142 4.05499L16.8139 3.77241C17.2074 3.40139 17.8246 3.41046 18.207 3.79289L20.207 5.79289C20.5895 6.17532 20.5986 6.79251 20.2275 7.18601L19.945 7.48571C21.8433 10.0496 22.9999 13.1833 22.9999 16.5V20C22.9999 20.4723 22.6695 20.8802 22.2075 20.9782C21.7455 21.0763 21.2779 20.8377 21.0861 20.4061C19.5548 16.9607 17.8884 14.1436 15.9191 11.7594L5.78873 22.5551C4.82264 23.5847 3.19624 23.6105 2.19791 22.6122L1.38775 21.802C0.389428 20.8037 0.415275 19.1773 1.44482 18.2112L12.2405 8.08084C9.85633 6.11151 7.03927 4.44513 3.5938 2.91381C3.16223 2.722 2.92368 2.2544 3.02172 1.79241ZM13.7415 9.41504L2.81338 19.6696C2.60747 19.8629 2.6023 20.1881 2.80197 20.3878L3.61213 21.198C3.81179 21.3976 4.13707 21.3925 4.33029 21.1866L14.5849 10.2585C14.3099 9.97106 14.0289 9.69005 13.7415 9.41504ZM8.31869 3.02736C10.6049 4.30007 12.6125 5.70113 14.4033 7.30303C15.2115 8.026 15.9739 8.78848 16.6969 9.59669C18.2988 11.3875 19.6999 13.3951 20.9726 15.6813C20.7848 12.8712 19.6408 10.2169 17.8574 8.06282C17.2794 7.36462 16.6353 6.72057 15.9371 6.14252C13.783 4.35913 11.1287 3.21514 8.31869 3.02736Z"
    />
  </svg>
);

export const Pin = () => (
  <svg
    width="24px"
    height="24px"
    strokeWidth="1.5"
    viewBox="0 0 23 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20 10C20 14.4183 12 22 12 22C12 22 4 14.4183 4 10C4 5.58172 7.58172 2 12 2C16.4183 2 20 5.58172 20 10Z"
      strokeWidth="1.5"
    ></path>
    <path
      d="M12 11C12.5523 11 13 10.5523 13 10C13 9.44772 12.5523 9 12 9C11.4477 9 11 9.44772 11 10C11 10.5523 11.4477 11 12 11Z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></path>
  </svg>
);

export const UpRightArrow = () => (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    strokeWidth="1.5"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.17137 14.8284L14.8282 9.17152M14.8282 9.17152H9.87848M14.8282 9.17152V14.1213"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></path>
    <path
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></path>
  </svg>
);

export const Galaxy = () => (
  <svg
    className="fill"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 514.526 514.526"
  >
    <g>
      <path
        d="M19.76,353.753c0.867,0.325,1.756,0.479,2.63,0.479c3.037,0,5.896-1.859,7.024-4.871   C52.608,287.453,98.761,219.98,159.371,159.37c2.929-2.929,2.929-7.678,0-10.606c-2.929-2.929-7.678-2.929-10.606,0   C86.672,210.856,39.298,280.227,15.368,344.098C13.915,347.977,15.881,352.3,19.76,353.753z"
        stroke="none"
      />
      <path
        d="M6.665,413.005c0.284,0.032,0.565,0.047,0.845,0.047c3.768,0,7.015-2.833,7.444-6.665   c0.683-6.088,1.735-12.475,3.129-18.985c0.867-4.05-1.713-8.037-5.764-8.904c-4.049-0.865-8.036,1.714-8.904,5.764   c-1.497,6.993-2.63,13.875-3.367,20.454C-0.414,408.833,2.549,412.544,6.665,413.005z"
        stroke="none"
      />
      <path
        d="M16.083,445.315c-0.833-4.057-4.801-6.672-8.856-5.836c-4.057,0.834-6.67,4.799-5.836,8.856   c3.549,17.266,10.973,31.645,22.064,42.736c1.464,1.465,3.384,2.197,5.303,2.197c1.919,0,3.839-0.732,5.303-2.197   c2.929-2.929,2.929-7.677,0-10.606C25.081,471.484,19.032,459.658,16.083,445.315z"
        stroke="none"
      />
      <path
        d="M490.83,171.44c-3.831-1.579-8.214,0.245-9.792,4.075c-24.321,58.988-69.027,122.786-125.881,179.641   c-2.929,2.929-2.929,7.678,0,10.606c1.464,1.464,3.384,2.197,5.303,2.197s3.839-0.732,5.303-2.197   c58.221-58.221,104.085-123.755,129.142-184.529C496.484,177.403,494.659,173.019,490.83,171.44z"
        stroke="none"
      />
      <path
        d="M507.861,101.528c-4.117-0.468-7.827,2.501-8.289,6.617c-0.861,7.673-2.305,15.789-4.292,24.123   c-0.961,4.029,1.526,8.074,5.556,9.035c0.585,0.14,1.17,0.206,1.746,0.206c3.392,0,6.468-2.317,7.289-5.762   c2.129-8.927,3.679-17.652,4.608-25.931C514.94,105.701,511.978,101.99,507.861,101.528z"
        stroke="none"
      />
      <path
        d="M498.443,69.211c0.729,3.548,3.853,5.991,7.338,5.991c0.5,0,1.009-0.05,1.518-0.155c4.057-0.834,6.67-4.799,5.836-8.856   c-3.55-17.267-10.973-31.645-22.064-42.736c-2.929-2.929-7.678-2.929-10.606,0c-2.929,2.929-2.929,7.678,0,10.606   C489.446,43.041,495.494,54.867,498.443,69.211z"
        stroke="none"
      />
      <path
        d="M287.202,374.597c-90.916,74.396-181.876,103.421-216.285,69.013c-2.929-2.929-7.678-2.929-10.606,0   c-2.929,2.929-2.929,7.678,0,10.606c12.482,12.482,30.009,18.765,51.771,18.765c14.374,0,30.598-2.743,48.428-8.251   c41.679-12.877,90.046-40.764,136.191-78.524c3.206-2.623,3.678-7.348,1.055-10.554   C295.133,372.446,290.407,371.973,287.202,374.597z"
        stroke="none"
      />
      <path
        d="M333.042,333.042c-4.847,4.847-9.828,9.671-14.804,14.337c-3.021,2.833-3.174,7.58-0.34,10.601   c1.476,1.574,3.472,2.37,5.472,2.37c1.839,0,3.682-0.672,5.129-2.029c5.093-4.776,10.19-9.712,15.15-14.672   c2.929-2.929,2.929-7.678,0-10.606C340.72,330.113,335.971,330.113,333.042,333.042z"
        stroke="none"
      />
      <path
        d="M222.58,141.625c1.67,0,3.352-0.555,4.745-1.696C318.242,65.533,409.203,36.509,443.61,70.917   c2.929,2.929,7.678,2.929,10.606,0c2.929-2.929,2.929-7.678,0-10.606c-20.727-20.727-55.375-24.362-100.2-10.514   c-41.679,12.877-90.046,40.764-136.19,78.524c-3.206,2.623-3.678,7.348-1.055,10.554   C218.254,140.686,220.408,141.625,222.58,141.625z"
        stroke="none"
      />
      <path
        d="M176.181,183.68c1.919,0,3.839-0.732,5.303-2.197c4.85-4.85,9.831-9.673,14.804-14.336   c3.022-2.833,3.174-7.58,0.341-10.601c-2.833-3.021-7.58-3.174-10.601-0.341c-5.09,4.773-10.188,9.709-15.15,14.672   c-2.929,2.929-2.929,7.678,0,10.606C172.342,182.948,174.261,183.68,176.181,183.68z"
        stroke="none"
      />
      <path
        d="M207.767,406.9c1.199,0,2.416-0.288,3.545-0.896c36.445-19.596,74.56-48.805,110.223-84.468   c41.977-41.976,75.262-87.776,93.725-128.963c19.462-43.416,20.208-77.299,2.1-95.407c-2.929-2.929-7.678-2.929-10.606,0   c-2.929,2.929-2.929,7.678,0,10.606c13.2,13.2,11.312,41.873-5.181,78.665c-17.735,39.563-49.926,83.774-90.644,124.492   c-34.643,34.643-71.546,62.951-106.72,81.864c-3.648,1.961-5.016,6.509-3.054,10.157C202.509,405.468,205.095,406.9,207.767,406.9z   "
        stroke="none"
      />
      <path
        d="M203.597,203.597c31.393-31.393,65.103-57.915,97.485-76.7c3.583-2.078,4.803-6.668,2.724-10.25   c-2.079-3.584-6.67-4.803-10.25-2.724c-33.491,19.428-68.266,46.77-100.565,79.068c-41.976,41.977-75.262,87.776-93.725,128.963   c-19.462,43.416-20.208,77.299-2.1,95.407c1.464,1.465,3.384,2.197,5.303,2.197c1.919,0,3.839-0.732,5.303-2.197   c2.929-2.929,2.929-7.678,0-10.606c-13.2-13.2-11.312-41.873,5.181-78.665C130.688,288.527,162.88,244.315,203.597,203.597z"
        stroke="none"
      />
      <path
        d="M203.532,325.597c6.715,0,15.437-3.253,26.317-9.781c14.433-8.66,31.288-22.335,47.459-38.508   c16.172-16.172,29.848-33.027,38.508-47.459c10.744-17.907,12.615-29.963,5.719-36.858c-19.481-19.482-77.739,37.648-84.318,44.227   s-63.709,64.834-44.227,84.318C195.696,324.241,199.195,325.597,203.532,325.597z M213.581,289.156   c8.11-12.682,20.271-27.36,34.243-41.333c13.972-13.972,28.651-26.133,41.333-34.243c12.102-7.74,18.826-9.534,21.424-9.635   c-0.102,2.598-1.896,9.323-9.635,21.424c-8.11,12.681-20.271,27.36-34.243,41.332c-13.972,13.972-28.651,26.133-41.332,34.244   c-12.102,7.739-18.827,9.534-21.424,9.635C204.047,307.982,205.842,301.257,213.581,289.156z"
        stroke="none"
      />
      <path
        d="M163.943,381.385c34.958,0,90.969-37.452,135.48-81.963c56.171-56.171,101.095-130.646,73.711-158.029   c-27.383-27.384-101.858,17.541-158.029,73.711c-56.171,56.171-101.095,130.646-73.711,158.029   C147.077,378.818,154.785,381.385,163.943,381.385z M159.728,312.739c13.571-27.143,37.004-58.05,65.983-87.028   s59.886-52.412,87.028-65.983c15.145-7.572,28.413-11.51,37.853-11.51c5.302,0,9.396,1.243,11.936,3.782   c7.059,7.059,4.097,26.136-7.729,49.788c-13.571,27.143-37.004,58.05-65.983,87.029c-28.979,28.979-59.886,52.412-87.028,65.983   c-23.651,11.826-42.729,14.787-49.788,7.729C144.941,355.468,147.902,336.39,159.728,312.739z"
        stroke="none"
      />
    </g>
  </svg>
);

export const Navigate = () => (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    strokeWidth="1.5"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4039_354)">
      <path
        d="M16 11H10C9 11 8 12 8 13V14M16 11L14 9M16 11L14 13"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M1.42426 11.5757L11.5757 1.42426C11.8101 1.18995 12.1899 1.18995 12.4243 1.42426L22.5757 11.5757C22.8101 11.8101 22.81 12.1899 22.5757 12.4243L12.4243 22.5757C12.1899 22.8101 11.8101 22.81 11.5757 22.5757L1.42426 12.4243C1.18995 12.1899 1.18995 11.8101 1.42426 11.5757Z"
        strokeWidth="1.5"
        strokeLinejoin="round"
      ></path>
    </g>
    <defs>
      <clipPath id="clip0_4039_354">
        <rect width="24" height="24" fill="white"></rect>
      </clipPath>
    </defs>
  </svg>
);

export const MapArrow = () => (
  <svg
    width="24px"
    height="24px"
    strokeWidth="1.5"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.03132 8.91684L19.508 4.58337C19.8835 4.47824 20.2294 4.82421 20.1243 5.19967L15.7908 20.6763C15.6642 21.1284 15.0407 21.1726 14.8517 20.7429L11.6034 13.3605C11.5531 13.246 11.4616 13.1546 11.3471 13.1042L3.96477 9.85598C3.53507 9.66692 3.57926 9.04342 4.03132 8.91684Z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></path>
  </svg>
);

export const MapArrowCircle = () => (
  <svg
    width="24px"
    height="24px"
    strokeWidth="1.5"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="12" cy="12" r="10" strokeWidth="1.5"></circle>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.9304 17.869C13.6084 18.7988 12.2931 18.798 11.9721 17.8678L10.3524 13.1739L5.78287 11.2307C4.87733 10.8456 4.96832 9.53344 5.91837 9.27705L16.1497 6.51591C16.9526 6.29922 17.6707 7.0693 17.3986 7.85518L13.9304 17.869Z"
      strokeWidth="1.5"
    ></path>
  </svg>
);

export const Search = () => (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    strokeWidth="1.5"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17 17L21 21"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></path>
    <path
      d="M3 11C3 15.4183 6.58172 19 11 19C13.213 19 15.2161 18.1015 16.6644 16.6493C18.1077 15.2022 19 13.2053 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11Z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></path>
  </svg>
);

export const XMark = () => (
  <svg
    width="24px"
    height="24px"
    strokeWidth="1.5"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.75827 17.2426L12.0009 12M17.2435 6.75736L12.0009 12M12.0009 12L6.75827 6.75736M12.0009 12L17.2435 17.2426"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></path>
  </svg>
);

export const Flag = () => (
  <svg
    width="24px"
    height="24px"
    strokeWidth="1.5"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5 15L5.95039 4.54568C5.97849 4.23663 6.23761 4 6.54793 4H20.343C20.6958 4 20.9725 4.30295 20.9405 4.65432L20.0496 14.4543C20.0215 14.7634 19.7624 15 19.4521 15H5ZM5 15L4.4 21"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></path>
  </svg>
);

export const FlagCircled = () => (
  <svg
    width="24px"
    height="24px"
    strokeWidth="1.5"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 21.5V15.5M9 15.5V6.99654C9 6.5444 9.48113 6.25472 9.88073 6.46627L16.5505 9.99731C16.9654 10.217 16.9787 10.8067 16.5739 11.0447L9 15.5ZM22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></path>
  </svg>
);

export const Bookmark = () => (
  <svg
    width="24px"
    height="24px"
    strokeWidth="1.5"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5 21V5C5 3.89543 5.89543 3 7 3H17C18.1046 3 19 3.89543 19 5V21L13.0815 17.1953C12.4227 16.7717 11.5773 16.7717 10.9185 17.1953L5 21Z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></path>
  </svg>
);

export const BookmarkFilled = () => (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    strokeWidth="1.5"
    className="fill"
  >
    <path
      d="M5 21V5C5 3.89543 5.89543 3 7 3H17C18.1046 3 19 3.89543 19 5V21L13.0815 17.1953C12.4227 16.7717 11.5773 16.7717 10.9185 17.1953L5 21Z"
      fill="#443a2c"
      stroke="#443a2c"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></path>
  </svg>
);
